
export const totalOptions = {
    chart: {
        height: 250,
        type: "line",
        stacked: false,
        toolbar: {
            show: false,
        },
    },
    dataLabels: {
        enabled: false
    },
    markers: {
        size: 4,
        shape: 'square'
    },
    colors: ["#bbb"],
    stroke: {
        width: 4,
        curve: "smooth",
    },
    theme: {
        mode: 'light'
    },
    xaxis: {
        labels: {
            show: false,
        }
    },
    yaxis: {
        axisTicks: {
            show: true,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            style: {
                colors: "#000",
                fontSize: 13,
                fontWeight: 600,
                cssClass: 'apexcharts-yaxis-label'
            },
            padding: -5,
            formatter: function (value){
                return value != undefined ? value.toLocaleString() : value
            }
        },
        title: {
            text: "yaxis",
            style: {
                color: "#000",
            }
        }
    },
    tooltip: {
        shared: true,
        intersect: false,
        x: {
            show: true
        },
        theme: 'dark',
        marker: {
            show: true,
            fillColors: "#555",
        }
    },
    legend: {
        horizontalAlign: "center",
        fontSize: 12,
        fontWeight: 600,
        offsetX: 0,
        markers: {
            offsetX: 3
        },
    }
}

export const pspLabelVariant = {
    get(psp) {
        switch (psp) {
            case 'mellat':
                return '#b72f11';
            case 'novin':
                return '#9c27b0';
            case 'sepehr':
                return '#f387e4';
            case 'parsian':
                return '#443d36';
            case 'saman':
                return '#3f51b5';
            case 'pasargad':
                return '#f0c239';
            case 'asanpardakht':
                return '#009688';
            case 'irankish':
                return '#b91133';
        }
        return '#000'
    }
}

export const transactionStatusVariant = {
    get(status){
        switch (status) {
            case 'ناموفق':
                return '#fd0000'
            case 'موفق':
                return '#02a104'
        }
    }
}